// extracted by mini-css-extract-plugin
export var footer = "_mm-5";
export var fulfillmentInput = "_mm-0";
export var shipDateInput = "_mm-1";
export var shipmentModal = "_mm-2";
export var shipmentModalContent = "_mm-3";
export var tableContainer = "_mm-4";